import { useExportMenuSectionTitle } from './useExportMenuSectionTitle';
import { useManageUsersSectionTitle } from './useManageUsersSectionTitle';
import { useExportUnsubscribedUsersLink } from './useExportUnsubscribedUsersLink';
import { useSubscribeUsersToChannelLink } from './useSubscribeUsersToChannelLink';
import { useUnsubscribeUsersFromChannelLink } from './useUnsubscribeUsersFromChannelLink';

export const useSecondaryActionMenuOptions = () => {
  // Menu section titles
  const exportMenuSectionTitle = useExportMenuSectionTitle();
  const manageUsersSectionTitle = useManageUsersSectionTitle();

  // Menu links
  const exportUnsubscribedUsersLink = useExportUnsubscribedUsersLink();
  const subscribeUsersToChannelLink = useSubscribeUsersToChannelLink();
  const unsubscribeUsersFromChannelLink = useUnsubscribeUsersFromChannelLink();

  return [
    // Export section
    exportMenuSectionTitle,
    exportUnsubscribedUsersLink,

    // Manage users section
    manageUsersSectionTitle,
    subscribeUsersToChannelLink,
    unsubscribeUsersFromChannelLink,
  ];
};
